import { Injectable } from '@angular/core';
import { ArrayHelper } from './array.helper';
import { ColorHelper } from './color.helper';
import { CookieHelper } from './cookie.helper';
import { FileHelper } from './file.helper';
import { HtmlHelper } from './html.helper';
import { ImageHelper } from './image.helper';
import { IsHelper } from './is.helper';
import { NumberHelper } from './number.helper';
import { ObjectHelper } from './object.helper';
import { RedRobinHelper } from './redrobin.helper';
import { StringHelper } from './string.helper';
import { UnitHelper } from './unit.helper';

@Injectable()
export class Helper {
	is = new IsHelper();
	array: ArrayHelper = new ArrayHelper();
	string: StringHelper = new StringHelper();
	color: ColorHelper = new ColorHelper();
	image: ImageHelper = new ImageHelper();
	unit: UnitHelper = new UnitHelper();
	html = new HtmlHelper();
	cookie = new CookieHelper();
	object = new ObjectHelper();
	number = new NumberHelper();
	file = new FileHelper();
	rr = new RedRobinHelper();
}
